/**
 * Pearla 品牌 - Member 页面配置
 */
import novelarcVipIcon from '../icons/novelarc/vip.png'
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * Pearla 品牌特定主题配置
 */
export const theme = {
  // 头像边框色
  avatarBorder: '#F5F0FF',
  // 按钮背景色
  btnPrimaryBg: '#F5F0FF',
  // Top Up 按钮背景色
  topUpBtnBg: 'linear-gradient(315deg, #7761F7 0%, #F992FF 100%)',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/pearla/member_subscribe_bg.webp)',
} as const

/**
 * Pearla 品牌特定资源配置
 */
export const resources = {
  // 页面背景图
  memberBg: '/images/pearla/member-bg.webp',
  // 用户背景图
  userBg: '/images/pearla/user-bg.webp',
  // 用户默认头像
  userDefaultAvatar: '/images/pearla/user-default.png',
  // VIP 图标
  memberVip: novelarcVipIcon,
  // VIP 折扣图标
  memberVipDiscount: '/images/pearla/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
